import { useEffect, useRef } from 'react'

export default useUnstaleCleanup = (cleanup, deps = []) ->

  cleanupRef = useRef(cleanup)

  useEffect( ->
    cleanupRef.current = cleanup
    undefined
  )
  useEffect( ->
    ->
      cleanupRef.current()
  , deps)